"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectParagraphCommand = void 0;
var tslib_1 = require("tslib");
var search_1 = require("@devexpress/utils/lib/utils/search");
var selection_command_base_1 = require("./selection-command-base");
var SelectParagraphCommand = (function (_super) {
    tslib_1.__extends(SelectParagraphCommand, _super);
    function SelectParagraphCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectParagraphCommand.prototype.executeCore = function (_state, options) {
        var paragraphs = this.selection.activeSubDocument.paragraphs;
        var paragraphIndex = search_1.SearchUtils.normedInterpolationIndexOf(paragraphs, function (p) { return p.startLogPosition.value; }, options.param);
        var paragraph = paragraphs[paragraphIndex];
        this.selection.deprecatedSetSelection(paragraph.startLogPosition.value, paragraph.startLogPosition.value + paragraph.length, true, -1, true);
        return true;
    };
    return SelectParagraphCommand;
}(selection_command_base_1.SelectionCommandBase));
exports.SelectParagraphCommand = SelectParagraphCommand;
